import { getcase } from './getcase';
import { GetCaseResponse } from '../getcase';
import { CaseStatus } from '../schema';

const POLLING_INTERVAL = 5000; // 5 seconds
const TIMEOUT = 900000; // 15 minutes

export const getCaseUntilGenerated = (caseId: string, token: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<GetCaseResponse> => {
  return new Promise((resolve, reject) => {
    let intervalId: NodeJS.Timeout;

    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
      reject(new Error('Polling timed out after 120 seconds.'));
    }, TIMEOUT);

    const poll = async () => {
      try {
        const response = await getcase({ caseId }, token, setAccessToken, logout);
        if (response.status === CaseStatus.GENERATED) {
          clearInterval(intervalId);
          clearTimeout(timeoutId);
          resolve(response);
        } else if (response.status === CaseStatus.FAILED) {
          clearInterval(intervalId);
          clearTimeout(timeoutId);
          reject(new Error("Case generation failed."));
        }
      } catch (error) {
        // Don't reject on polling error, just log it and continue polling
        console.error('Error during polling:', error);
      }
    };

    intervalId = setInterval(poll, POLLING_INTERVAL);
    poll(); // Initial call
  });
};